import { Button, Form, FormLayout, TextField } from '@shopify/polaris';
import React, { useCallback, useState } from 'react'

export const AmazonForm = () => {

    const [clientId, setClientID] = useState('');
    const [clientSecret, setClientSecret] = useState('');
    const [url, setUrl] = useState('');

    const handleSubmit = useCallback((_event) => {
    }, []);

    const handleClientIdChange = useCallback((value) => setClientID(value), []);
    const handleClientSecretChange = useCallback((value) => setClientSecret(value), []);
    const handleUrlChange = useCallback((value) => setUrl(value), []);

    return (
        <Form onSubmit={handleSubmit}>
            <FormLayout>

                <TextField
                value={clientId}
                onChange={handleClientIdChange}
                    label="AMAZON_CLIENT_ID"
                    type="text"
                   placeholder="Please enter client id"
                    
                />
                <TextField
                   value={clientSecret}
                   onChange={handleClientSecretChange}
                    label="AMAZON_CLIENT_SECRET"
                    type="text"
                   placeholder="Please enter client secret"
                    
                />
                <TextField
                    value={url}
                    onChange={handleUrlChange}
                    label="REDIRECT_URL"
                    type="text"
                   placeholder="Please enter redirect url"
                    
                />
                <Button submit>Update</Button>
            </FormLayout>
        </Form>
    );
}
